// extracted by mini-css-extract-plugin
module.exports = {"opened":"CollapseStyles_opened__1BtUU","collapse":"CollapseStyles_collapse__2P5Mm","icon":"CollapseStyles_icon__116Tt","activeTitle":"CollapseStyles_activeTitle__3aub_"};